var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","justify-content":"flex-end"}},[_c('DxTagBox',{staticStyle:{"min-width":"180px"},attrs:{"items":_vm.avaliableDistances,"value":_vm.selectedDistance,"on-value-changed":_vm.setDistance}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }